export const getIntfName = (oData) => {
  let txt = oData?.name || '';
  let alias = oData?.alias;
  if (alias) txt = `${txt} (${alias})`;
  return txt;
};
